















































































































































import { Component } from 'vue-property-decorator'
import QuestionRadio from './QuestionRadio.vue'
import QuestionCheckBox from './QuestionCheckBox.vue'
import QuestionSelect from './QuestionSelect.vue'
import ExamResultQuestionBodyMixin from './ExamResultQuestionBodyMixin'
import { mixins } from 'vue-class-component'
import * as AceEditor from 'brace'
import 'brace/mode/javascript';
import 'brace/mode/typescript';
import 'brace/mode/ruby';
import 'brace/mode/python';
import 'brace/mode/html';
import 'brace/mode/json';
import 'brace/mode/sql';
import 'brace/theme/monokai'

@Component({
  components: {
    QuestionRadio,
    QuestionCheckBox,
    QuestionSelect
  }
})
export default class ExamResultQuestionBodyWeb extends mixins(ExamResultQuestionBodyMixin) {
  codeDialog = false
  dialogHTML = ""

  mounted() {
    document.addEventListener("click", this.handleCopy)
    document.addEventListener("click", this.handleZoomHighlight)

    this.$nextTick(this.setupAceEditor)
  }

  beforeDestroy() {
    document.removeEventListener("click", this.handleCopy)
    document.removeEventListener("click", this.handleZoomHighlight)
  }

  camelCaseToWords = function (text) {
    let result = text.replace(/([A-Z])/g, " $1")
    result = result.charAt(0).toUpperCase() + result.slice(1)
    return result.replaceAll("A I", "AI")
  }

  getMaxScore = function (skill, name) {
    const skillItem = skill.skillItems.find((si) => si.name.trim().toLowerCase() === name.trim().toLowerCase())
    if (!skillItem) return

    const allotments = skillItem.answerItems.map((ai) => ai.allotment)
    return Math.max(...allotments)
  }

  handleCopy(e) {
    if (e.target.classList.contains("highlight-copy-btn")) {
      navigator.clipboard.writeText(e.target.closest(".highlight-container").querySelector("code").innerText)
      e.target.querySelector(".action-name").innerText = "コピーしました！"

      setTimeout(() => {
        e.target.querySelector(".action-name").innerText = "コードをコピーする"
      }, 1000)
    }
  }

  handleZoomHighlight(e) {
    if (e.target.classList.contains("highlight-zoom-btn")) {
      this.dialogHTML = e.target.closest(".highlight-container").outerHTML
      this.codeDialog = true
    }
  }

  getAnswerMode() {
    const match = this.currentQuestion.body.match(/code,\s?"?(\w+)"?]/)
    const code =  match ? match[1] : ''
    return code && ["html", "javascript", "typescript", "ruby", "python", "json", "sql"].includes(code.toLowerCase()) ? code : null
  }

  setupAceEditor() {
    const mode = this.getAnswerMode()
    if (!mode) return

    const value = this.value
    const editor = AceEditor.edit("editor")
    editor.getSession().setMode(`ace/mode/${mode}`);
    editor.setTheme('ace/theme/monokai')
    editor.setReadOnly(true)
    editor.setValue((value.join("")), 1)
  }
}
